import { render, staticRenderFns } from "./tcustbase-add-or-v.vue?vue&type=template&id=c1e85b58&scoped=true&"
import script from "./tcustbase-add-or-v.vue?vue&type=script&lang=js&"
export * from "./tcustbase-add-or-v.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase-add-or-v.vue?vue&type=style&index=0&id=c1e85b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e85b58",
  null
  
)

export default component.exports